jQuery(document).ready(function() {
    // Check if component is added to the page
    if (jQuery('section.calendar').length) {

        let $ = jQuery;
        const $container = $(".js-calendar-wrapper");
        const $loadMoreBtn = $("#load-more-events");
        const $eventFilter = $(".event-filter");

        var $lastDay = null;
        var inFlight = false;   // real in-flight guard (the old `loading` var was never read)
        var request = null;     // handle so a filter change can abort a pending request
        var seenIds = {};       // event IDs already on the page, to defend against repeats

        // Index whatever the server rendered into the page on first load.
        function indexRendered() {
            seenIds = {};
            $container.find('.event-item[data-event-id]').each(function() {
                seenIds[this.getAttribute('data-event-id')] = true;
            });
        }

        function setBusy(busy) {
            inFlight = busy;
            $loadMoreBtn.prop('disabled', busy).toggleClass('is-loading', busy);
        }

        // Append a response, skipping events already shown and merging days that
        // the server split across two pages (it paginates by event, not by day).
        function appendResults(html) {
            var $incoming = $('<div></div>').append($.parseHTML(html));
            var added = 0;

            $incoming.find('.day-wrapper').each(function() {
                var $day = $(this);
                var date = $day.attr('data-date');

                $day.find('.event-item').each(function() {
                    var id = this.getAttribute('data-event-id');
                    if (!id) return;
                    if (seenIds[id]) {
                        $(this).remove();
                    } else {
                        seenIds[id] = true;
                    }
                });

                if (!$day.find('.event-item').length) {
                    return; // nothing new in this day
                }

                var $existing = date ?
                    $container.find('.day-wrapper[data-date="' + date + '"]').last() :
                    $();

                if ($existing.length) {
                    $existing.append($day.children());
                } else {
                    $container.append($day);
                }

                added++;
            });

            return added;
        }

        $eventFilter.on("change", function() {
            var dataFor = $(this).data('for');
            var value = $(this).val();

            $container.attr('data-' + dataFor, value);

            if (dataFor == 'year' && $container.attr('data-month') == '') {
                return;
            }

            // Cancel anything still in flight so a stale response can't append.
            if (request && request.readyState !== 4) {
                request.abort();
            }
            setBusy(false);

            $lastDay = null;   // was never reset - left a stale cursor after filtering
            seenIds = {};
            $container.attr('data-page', '0');
            $container.empty();

            loadResults(false);
        });

        $loadMoreBtn.on("click", function(e) {
            e.preventDefault();
            loadResults(true);
        });

        function loadResults(loadMore) {
            // Refuse to start a second request while one is still running. This is
            // the core fix: previously two overlapping clicks sent identical
            // requests (same page, same startDate) and appended the same events.
            if (inFlight) {
                return;
            }
            setBusy(true);

            var page = parseInt($container.attr('data-page'), 10);
            if (isNaN(page)) {
                page = 0;
            }
            page = page + 1;

            var today = $container.attr('data-today');

            if (!loadMore) {
                $loadMoreBtn.fadeOut();
            }

            var sendData = {
                action: 'events_ajax_handler',
                category: $container.attr('data-category'),
                today: today,
                month: $container.attr('data-month'),
                year: $container.attr('data-year'),
                page: page,
                startDate: loadMore ? ($lastDay || today) : today,
                _nocache: new Date().getTime(), // Cache busting
                nonce: ajaxadminurl.nonce
            };

            request = $.ajax({
                url: ajaxadminurl.ajaxurl,
                type: 'GET',
                data: sendData,
                dataType: 'html',
                cache: false,
                timeout: 10000
            })
            .done(function(html) {
                var trimmed = $.trim(html || '');

                // Structural test rather than an exact string match against markup.
                if (!trimmed || trimmed.indexOf('nothing-found') !== -1) {
                    $loadMoreBtn.fadeOut();
                    return;
                }

                var added = appendResults(trimmed);

                // The server paginates on `page`, so advance the cursor even if we
                // de-duplicated the response down to nothing.
                $container.attr('data-page', page);

                var $lastWrapper = $container.find('.day-wrapper').last();
                if ($lastWrapper.length) {
                    $lastDay = $lastWrapper.attr('data-date');
                }

                if (added) {
                    $loadMoreBtn.fadeIn();
                    if (window.AOS) {
                        // refresh, don't re-init the whole library on every append
                        if (typeof AOS.refreshHard === 'function') {
                            AOS.refreshHard();
                        } else if (typeof AOS.refresh === 'function') {
                            AOS.refresh();
                        }
                    }
                } else {
                    $loadMoreBtn.fadeOut();
                }
            })
            .fail(function(jqXHR, status) {
                if (status === 'abort') {
                    return;
                }
                // Don't strand the user with a hidden button on timeout/error.
                $loadMoreBtn.fadeIn();
                if (window.console) {
                    console.warn('[calendar] load more failed:', status);
                }
            })
            .always(function() {
                setBusy(false);
            });
        }

        indexRendered();
    }
});
